import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { MoveFolderDialogComponent } from './move-folder-dialog.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		NgSelectModule,
		FormsModule,
		ReactiveFormsModule,
		A11yModule,
		GoDialogContentDirective
	],
	declarations: [
		MoveFolderDialogComponent
	],
	exports: [
		MoveFolderDialogComponent
	],
	providers: [
		TranslatePipe
	]
})
export class MoveFolderDialogModule {}
